import React from "react";
import StyleEditor from "react-style-editor";

type CSSEditorProps = {
	defaultValue?: string;
	onChange?: (css) => any;
};

export default class CSSEditor extends React.Component<CSSEditorProps> {
	private _value: string;

	render() {
		const { defaultValue, onChange } = this.props;
		this._value = defaultValue;
		return (
			<StyleEditor
				outputFormats="preserved" // 'preserved', 'machine', 'pretty'
				// value
				// readonly
				defaultValue={defaultValue}
				onChange={(css) => {
					this._value = css;
					onChange(this._value);
				}}
				onBlur={() => {
					console.log("CSSEditor change:", this._value || ""); //.replaceAll("\\n", ""));
					onChange(this._value);
				}}
			/>
		);
	}
}
// e.g.
// `
//                     div {color:red;}
//                     /* Hello, World! */
//                     @media screen {
//                         article {
//                             display: flex;
//                         }
//                     }
//                 `
